/**
 * Phase-1 Org-Fundament (· 263) — Banner für Filialen in den Einstellungen.
 *
 * Weist darauf hin, dass zentrale Bereiche vom Hauptsitz vorgegeben und hier
 * schreibgeschützt sind. Rendert nichts für Hauptsitze/standalone-Händler.
 */
import { useEffect, useState } from "react";
import { Lock } from "lucide-react";
import api from "../../lib/api";

const AREA_LABELS = {
    intranet: "Intranet", invoices: "Rechnungen", accounting: "Buchhaltung",
    leasing_return: "Leasingrückgabe", marketing: "Marketing",
    marketplace: "Marktplatzeinstellungen", support: "Support / Tickets",
    email_templates: "E-Mail-Vorlagen", wms: "Warenwirtschaft",
    boni: "Boni / Hersteller / Händleraktionen", finance: "Finanzen",
    commissions: "Provisionen", employees: "Mitarbeiter",
    tax_data: "Steuerdaten", imprint: "Impressum", legal: "Rechtliches",
};

export default function FilialeInheritanceBanner() {
    const [org, setOrg] = useState(null);
    useEffect(() => {
        const load = () => api.get("/org/me").then((r) => setOrg(r.data)).catch(() => {});
        load();
        window.addEventListener("twowheels:org-changed", load);
        return () => window.removeEventListener("twowheels:org-changed", load);
    }, []);

    if (!org || !org.is_filiale) return null;
    const areas = (org.inherited_areas || []).map((a) => AREA_LABELS[a] || a);

    return (
        <div className="bg-blue-50 border-l-4 border-[#2563EB] rounded-sm px-4 py-3" data-testid="filiale-inheritance-banner">
            <div className="flex items-start gap-2">
                <Lock className="w-4 h-4 text-[#2563EB] mt-0.5 shrink-0" />
                <div>
                    <p className="text-sm font-bold text-[#111827]">
                        Filiale von {org.hauptsitz?.company_name || "Hauptsitz"} — zentrale Einstellungen sind vorgegeben
                    </p>
                    <p className="text-xs text-gray-600 mt-0.5">
                        Folgende Bereiche werden vom Hauptsitz verwaltet und sind hier schreibgeschützt:
                        {" "}<span className="font-medium">{areas.join(", ")}</span>.
                        Filial-eigen bleiben u. a. Anschrift, Werkstatt &amp; Disposition. Firmenname, Logo, Ansprechpartner, Standort-Code, DATEV &amp; Rechtsdokumente werden ausschließlich vom Hauptsitz gepflegt.
                    </p>
                </div>
            </div>
        </div>
    );
}
